import { Home as HomeIcon } from "@mui/icons-material";
import { ReactNode } from "react";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DropdownAvailableIconsEnum,
  IStyledAttributes,
} from "@ryde/shared";

type DropdownIconsMap = Map<DropdownAvailableIconsEnum, ReactNode>;

const dropdownIconsList: DropdownIconsMap = new Map([
  [DropdownAvailableIconsEnum.homeIcon, <HomeIcon sx={{ color: "#90A4AE" }} />],
]);

const OptionIconWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "option-Icon-wrapper",
})`
  display: flex;
  align-items: center;
  justify-content: center;

  svg,
  .empty-icon {
    width: 16px;
    height: 16px;
  }
`;

export const DropdownIconRenderer = (
  option: string | number,
  optionIconMapping?: Map<string | number, DropdownAvailableIconsEnum>,
): ReactNode => {
  if (!optionIconMapping?.values) {
    return;
  }

  const iconRenderPath = optionIconMapping?.get(option);

  if (iconRenderPath && dropdownIconsList.has(iconRenderPath)) {
    return (
      <OptionIconWrapper>
        {dropdownIconsList.get(iconRenderPath)}
      </OptionIconWrapper>
    );
  }

  return (
    <OptionIconWrapper>
      <div className="empty-icon" />
    </OptionIconWrapper>
  );
};
